$(document).on('click','.personal__content-dropdownn [data-type="cancel"]',function(){
  var id = $(this).attr('data-id');
    jQuery.ajax({
      url:     "/local/templates/symbiosislab/ajax/cancel_order.php", 
      type:     "POST", 
      dataType: "html", 
      data: "ID="+id, 
      success: function(response) { 
        window.location.reload();
      // console.log(response);
  }, 
  error: function(response) { 
    console.log(response);
  }
  });
}); 

$(document).on('click','.personal__content-dropdownn [data-type="tweak"]',function(){
  var id = $(this).attr('data-id');
    jQuery.ajax({
      url:     "/local/templates/symbiosislab/ajax/tweak_order.php", 
      type:     "POST", 
      dataType: "html", 
      data: "ID="+id, 
      success: function(response) { 
        if (response=='ok')
          window.location.reload();
        else
          alert(response);

      // console.log(response);
  }, 
  error: function(response) { 
    console.log(response);
  } 
  });
}); 

$('.personal__show-history').click(function(){
  $(this).parent().hide();
  $('.personal__dropdown-history-box .personal__content-dropdownn:hidden').fadeIn('1000');
}); 